let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aXEiz")).then(() => parcelRequire('lTc1q'));